<template>
  <div>
    <div class="offer-section py-5">
      <div class="container">
        <h3 class="mb-5 text-center">What We Offer</h3>

        <div class="row">
          <div class="col-md-6 col-12 mb-3">
            <ul class="list-unstyled d-flex flex-column justify-content-between h-100">
              <li
                class="bg-white p-3 rounded d-flex gap-2"
                v-for="service in services"
                :key="service.id"
              >
                <div
                  class="bg-primary icon-section d-flex justify-content-center align-items-center rounded"
                >
                <i :class="service.icon"></i>
                  <!-- <img
                    :src="require(`../../assets/Images/home/${service.image_src}.png`)"
                    alt=""
                  /> -->
                </div>
                <div class="text-section">
                  <h4 class="mb-2">{{service.title}}</h4>
                  <p class="mb-0">
                    {{service.text}}
                  </p>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-md-6 col-12 mb-3 d-flex align-items-center">
            <img
              src="../../assets/Images/home/offer.png"
              class="img-fluid"
              alt="dummmy image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      services: [
        {
          id: 1,
          text: "We offer essential digital skills training for success in today's fast-paced world. Our curated programs cover android development, web development, digital marketing, UX and UI design and more, providing practical experience and expert instruction to excel in the digital landscape.",
          title: "Digital skills training",
          image_src: "digital",
          icon: "bi-laptop"
        },
        {
          id: 2,
          text: "We provide modern, collaborative workspaces designed to foster creativity, innovation, and productivity. Equipped with state-of-the-art amenities and flexible arrangements, our spaces are ideal for you.",
          title: "Co-Workspace",
          image_src: "workspace",
          icon: "bi-house-up"
        },
        {
          id: 3,
          text: "Our streamlined outsourcing services connect businesses with skilled professionals for results-driven success. Developers, marketers, designers and more - we have the talent to meet your needs and help you scale cost-effectively.",
          title: "Talent outsourcing",
          image_src: "talent",
          icon: "bi-people-fill"
        },
      ],
    };
  },
};
</script>
  
  <style scoped>
.offer-section {
  min-height: 70vh;
  background: rgba(51, 92, 166, 0.05);
}

.offer-section i {
  font-size: 30px;
  color: white;
}

ul li {
  margin-left: 0;
}

.icon-section {
  width: 10%;
}

.text-section {
  width: 90%;
}

.dummy-img {
  min-height: 400px;
  object-fit: cover;
  width: 100%;
}

@media (max-width: 769px) {
  .icon-section{
    width: 20%;
  }

  .text-section {
  width: 80%;
}

.dummy-img {
  min-height: 400px;
  object-fit: cover;
  width: 100%;
}
}
</style>